import { httpRequest } from "@services/http";
import type { Feature } from "./cmdCreateFeature";

export class CommandUpdateFeature {
  async run(featureId: number, payload: { name?: string; parent_id?: number | null }): Promise<Feature> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/features/${featureId}`;
    try {
      return await httpRequest<Feature>(url, { method: "PATCH", body: payload });
    } catch (error) {
      console.error("Error updating feature:", error);
      throw error;
    }
  }
}
